var _path, _g, _g2, _g3, _path2, _path3, _g4, _g5, _path4, _g6, _g7, _path5, _path6, _path7, _path8, _g8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g9, _path17, _path18, _g10, _path19, _path20, _path21, _path22, _g11, _g12, _path23, _path24, _path25, _path26, _g13, _g14, _path27, _path28, _g15, _path29, _g16, _path30, _path31, _path32, _path33, _g17, _g18, _path34, _g19, _g20, _g21, _g22, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 524,
    height: 486,
    viewBox: "0 0 524 486",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.434 36.8316L256.912 270.682L206.338 28.3L177.434 36.8316Z",
    fill: "url(#paint0_linear_4003_135)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.614 98.1285L266.842 326.856L235.154 95.26L229.823 95.2694L209.614 98.1285Z",
    fill: "url(#paint1_linear_4003_135)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.419 35.6271L250.363 268.884L227.391 34.2966L221.994 33.9823L201.419 35.6271Z",
    fill: "url(#paint2_linear_4003_135)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.001 19.9995L261.591 252.803L253.501 16.7563L235.001 19.9995Z",
    fill: "url(#paint3_linear_4003_135)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240.428 214.768L270.246 324.538L260.523 212.994L240.428 214.768Z",
    fill: "url(#paint4_linear_4003_135)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28479 186.06L231.002 271.788L23.2417 173.108L2.28479 186.06Z",
    fill: "url(#paint5_linear_4003_135)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.886 62.7531L284.841 215.347L420.776 74.7698L406.886 62.7531Z",
    fill: "url(#paint6_linear_4003_135)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.043 59.8701L282.666 217.64L422.474 80.5663L398.043 59.8701Z",
    fill: "url(#paint7_linear_4003_135)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M334.18 448.496L269.701 320.998L310.284 455.029L334.18 448.496Z",
    fill: "url(#paint8_linear_4003_135)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.938 476.115L259.001 304L225.25 467.186L254.938 476.115Z",
    fill: "url(#paint9_linear_4003_135)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.928 454.962L267.666 324.768L330.303 465.006L354.928 454.962Z",
    fill: "url(#paint10_linear_4003_135)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M408.84 413.852L263.607 289.083L396.396 428.28L408.84 413.852Z",
    fill: "url(#paint11_linear_4003_135)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M381.648 433.723L246 268L367.309 448.663L381.648 433.723Z",
    fill: "url(#paint12_linear_4003_135)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M411.812 380.752L287.001 307L404.536 395.314L411.812 380.752Z",
    fill: "url(#paint13_linear_4003_135)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M447.775 104.01L256.019 250.702L465.077 123.311L447.775 104.01Z",
    fill: "url(#paint14_linear_4003_135)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_b_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482.254 300.433L243.001 248L487.035 314.901L482.254 300.433Z",
    fill: "url(#paint15_linear_4003_135)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M462.57 317.44L276 253.999L463.332 336.488L462.57 317.44Z",
    fill: "url(#paint16_linear_4003_135)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M474.24 289.184L275.999 254L461.985 301.976L474.24 289.184Z",
    fill: "url(#paint17_linear_4003_135)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M207.026 451.929L248.74 314.756L184.119 444.118L207.026 451.929Z",
    fill: "url(#paint18_linear_4003_135)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M242.796 456.277L259 318L252.082 456.134L242.796 456.277Z",
    fill: "url(#paint19_linear_4003_135)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8154 294.029L212.001 268L28.9789 268.015L30.8154 294.029Z",
    fill: "url(#paint20_linear_4003_135)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2503 282.92L233.999 269L11.4688 263.246L17.2503 282.92Z",
    fill: "url(#paint21_linear_4003_135)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M500.813 159.014L254.638 257.899L515.188 198.433L500.813 159.014Z",
    fill: "url(#paint22_linear_4003_135)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M491.533 192.263L264.277 255.36L488.74 181.444L491.533 192.263Z",
    fill: "url(#paint23_linear_4003_135)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.934 83.5927L252.698 281.053L116.673 70.233L101.934 83.5927Z",
    fill: "url(#paint24_linear_4003_135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.626 138.23L241.52 273.575L143.972 140.395L152.626 138.23Z",
    fill: "url(#paint25_linear_4003_135)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M142.426 64.2299L247.929 274.926L157.399 51.3804L142.426 64.2299Z",
    fill: "url(#paint26_linear_4003_135)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M179.577 123.037L239.085 266.639L171.595 124.766L179.577 123.037Z",
    fill: "url(#paint27_linear_4003_135)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.611 112.729L215.378 253.621L68.7079 99.5253L50.611 112.729Z",
    fill: "url(#paint28_linear_4003_135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8637 128.602L207.813 246.148L76.5921 129.65L86.8637 128.602Z",
    fill: "url(#paint29_linear_4003_135)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1284 135.476L233.835 268.412L59.0483 119.154L41.1284 135.476Z",
    fill: "url(#paint30_linear_4003_135)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8173 148.417L224.875 261.229L70.9166 150.731L81.8173 148.417Z",
    fill: "url(#paint31_linear_4003_135)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50887 207.385L219.557 258.584L26.0116 192.949L3.50887 207.385Z",
    fill: "url(#paint32_linear_4003_135)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.329 217.019L212.19 256.841L26.093 222.066L35.329 217.019Z",
    fill: "url(#paint33_linear_4003_135)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.22 26.6975L265.533 299.844L316.08 27.3112L288.22 26.6975Z",
    fill: "url(#paint34_linear_4003_135)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_b_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.932 39.2508L271.81 320.938L304.782 40.8719L317.932 39.2508Z",
    fill: "url(#paint35_linear_4003_135)"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_b_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.603 55.7101L243.638 270.91L406.913 66.5306L383.603 55.7101Z",
    fill: "url(#paint36_linear_4003_135)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_b_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.479 64.5148L257.175 247.919L389.299 59.0818L399.479 64.5148Z",
    fill: "url(#paint37_linear_4003_135)"
  })))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M465.054 313.243L279.615 251.751L470.081 339.247L465.054 313.243Z",
    fill: "url(#paint38_linear_4003_135)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M435.582 320.623L268.013 249.877L435.011 314.003L435.582 320.623Z",
    fill: "url(#paint39_linear_4003_135)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M466.86 365.033L296.2 277.682L457.82 390.251L466.86 365.033Z",
    fill: "url(#paint40_linear_4003_135)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M448.014 374.884L302.324 281.699L451.1 368.577L448.014 374.884Z",
    fill: "url(#paint41_linear_4003_135)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_b_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489.273 154.479L276.215 254.458L498.558 172.611L489.273 154.479Z",
    fill: "url(#paint42_linear_4003_135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.243 172.693L283.899 251.502L484.398 163.407L488.243 172.693Z",
    fill: "url(#paint43_linear_4003_135)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_b_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.674 229.216L294.074 247.99L504.723 262.134L503.674 229.216Z",
    fill: "url(#paint44_linear_4003_135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.465 252.149L301.953 248.264L489.043 243.374L488.465 252.149Z",
    fill: "url(#paint45_linear_4003_135)"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M491.028 105.515L246.89 247.376L491.576 138.636L491.028 105.515Z",
    fill: "url(#paint46_linear_4003_135)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M465.22 138.62L255.827 243.061L458.49 129.995L465.22 138.62Z",
    fill: "url(#paint47_linear_4003_135)"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_b_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.993 450.867L264.851 253.52L184.136 434.401L215.993 450.867Z",
    fill: "url(#paint48_linear_4003_135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.886 425.139L262.08 260.417L207.104 430.296L198.886 425.139Z",
    fill: "url(#paint49_linear_4003_135)"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M433.13 388.863L234.554 260.516L417.678 419.693L433.13 388.863Z",
    fill: "url(#paint50_linear_4003_135)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_b_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.975 399.272L241.531 266.233L412.869 391.649L407.975 399.272Z",
    fill: "url(#paint51_linear_4003_135)"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M339.442 461.627L248.322 252.21L299.491 467.463L339.442 461.627Z",
    fill: "url(#paint52_linear_4003_135)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M306.435 449.559L250.555 260.223L317.363 448.872L306.435 449.559Z",
    fill: "url(#paint53_linear_4003_135)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M156.083 395.275L223 310L158.401 401.311L156.083 395.275Z",
    fill: "url(#paint54_linear_4003_135)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M149.346 420.43L225 306.999L139.345 400.111L149.346 420.43Z",
    fill: "url(#paint55_linear_4003_135)"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.196 433.108L230.998 305L112.505 408.057L123.196 433.108Z",
    fill: "url(#paint56_linear_4003_135)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.039 411.106L210.804 303.756L69.2502 388.657L80.039 411.106Z",
    fill: "url(#paint57_linear_4003_135)"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3359 388.896L230.809 290.128L48.1478 369.522L67.3359 388.896Z",
    fill: "url(#paint58_linear_4003_135)"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_b_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0797 342.438L208.999 268L25.118 328.346L46.0797 342.438Z",
    fill: "url(#paint59_linear_4003_135)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_f_4003_135)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 248.5,
    cy: 247.5,
    r: 89.5,
    fill: "white",
    fillOpacity: 0.54
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_f_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390 243.5C390 311.155 328.887 366 253.5 366C178.113 366 117 311.155 117 243.5C117 175.845 178.113 121 253.5 121C328.887 121 390 175.845 390 243.5Z",
    fill: "white",
    fillOpacity: 0.35
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_4003_135)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.5,
    cy: 244.5,
    rx: 72.5,
    ry: 73.5,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4003_135",
    x: 205.613,
    y: 91.2598,
    width: 65.2285,
    height: 239.596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4003_135"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4003_135",
    x: 197.42,
    y: 29.9824,
    width: 56.9434,
    height: 242.9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4003_135"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4003_135",
    x: 231.002,
    y: 12.7559,
    width: 34.5898,
    height: 244.047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4003_135"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_4003_135",
    x: 283.842,
    y: 61.7539,
    width: 137.936,
    height: 154.594,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_4003_135"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_4003_135",
    x: 281.666,
    y: 58.8691,
    width: 141.807,
    height: 159.771,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_4003_135"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_4003_135",
    x: 221.25,
    y: 300,
    width: 41.75,
    height: 180.115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4003_135"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_4003_135",
    x: 263.666,
    y: 320.768,
    width: 95.2617,
    height: 148.238,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4003_135"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_b_4003_135",
    x: 239,
    y: 244,
    width: 252.035,
    height: 74.9004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4003_135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4003_135",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_4003_135",
    x: 97.9336,
    y: 66.2324,
    width: 158.766,
    height: 218.82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4003_135"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_4003_135",
    x: 46.6113,
    y: 95.5254,
    width: 172.766,
    height: 162.096,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4003_135"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_4003_135",
    x: 261.533,
    y: 22.6973,
    width: 60.3984,
    height: 302.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4003_135"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_b_4003_135",
    x: 267.811,
    y: 35.25,
    width: 54.1211,
    height: 289.688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4003_135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4003_135",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_b_4003_135",
    x: 239.639,
    y: 51.7109,
    width: 171.273,
    height: 223.199,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4003_135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4003_135",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_b_4003_135",
    x: 253.176,
    y: 55.082,
    width: 150.303,
    height: 196.836,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4003_135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4003_135",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_b_4003_135",
    x: 272.215,
    y: 150.479,
    width: 230.344,
    height: 107.979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4003_135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4003_135",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_b_4003_135",
    x: 290.074,
    y: 225.215,
    width: 218.648,
    height: 40.9199,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4003_135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4003_135",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_b_4003_135",
    x: 180.137,
    y: 249.52,
    width: 88.7148,
    height: 205.348,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4003_135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4003_135",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_b_4003_135",
    x: 237.531,
    y: 262.232,
    width: 179.338,
    height: 141.039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4003_135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4003_135",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_4003_135",
    x: 108.506,
    y: 301,
    width: 126.492,
    height: 136.107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4003_135"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_4003_135",
    x: 65.25,
    y: 299.756,
    width: 149.555,
    height: 115.35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4003_135"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_b_4003_135",
    x: 21.1172,
    y: 264,
    width: 191.883,
    height: 82.4375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4003_135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4003_135",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_4003_135",
    x: 140,
    y: 139,
    width: 217,
    height: 217,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.5,
    result: "effect1_foregroundBlur_4003_135"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_4003_135",
    x: 85,
    y: 89,
    width: 337,
    height: 309,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_4003_135"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_4003_135",
    x: 160,
    y: 152,
    width: 183,
    height: 185,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.5,
    result: "effect1_foregroundBlur_4003_135"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4003_135",
    x1: 197.89,
    y1: 30.9792,
    x2: 276.278,
    y2: 264.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4003_135",
    x1: 230.511,
    y1: 96.7028,
    x2: 256.524,
    y2: 328.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4003_135",
    x1: 222.633,
    y1: 35.464,
    x2: 234.665,
    y2: 269.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4003_135",
    x1: 249.813,
    y1: 18.0382,
    x2: 245.874,
    y2: 252.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4003_135",
    x1: 250.476,
    y1: 213.881,
    x2: 265.257,
    y2: 325.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4003_135",
    x1: 20.0436,
    y1: 176.283,
    x2: 118.005,
    y2: 339.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4003_135",
    x1: 419.603,
    y1: 74.0477,
    x2: 297.066,
    y2: 225.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4003_135",
    x1: 397.817,
    y1: 96.4542,
    x2: 231.809,
    y2: 274.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4003_135",
    x1: 322.232,
    y1: 451.763,
    x2: 279.127,
    y2: 317.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4003_135",
    x1: 240.094,
    y1: 471.651,
    x2: 281.377,
    y2: 309.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4003_135",
    x1: 342.615,
    y1: 459.984,
    x2: 277.915,
    y2: 320.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4003_135",
    x1: 400.738,
    y1: 426.044,
    x2: 239.231,
    y2: 330.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4003_135",
    x1: 372.009,
    y1: 446.696,
    x2: 202.35,
    y2: 333.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4003_135",
    x1: 408.885,
    y1: 381.934,
    x2: 221.774,
    y2: 332.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4003_135",
    x1: 462.409,
    y1: 116.908,
    x2: 316.499,
    y2: 299.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4003_135",
    x1: 488.007,
    y1: 316.037,
    x2: 304.662,
    y2: 393.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4003_135",
    x1: 464.573,
    y1: 354.884,
    x2: 277.979,
    y2: 378.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4003_135",
    x1: 473.418,
    y1: 303.257,
    x2: 275.855,
    y2: 302.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4003_135",
    x1: 195.573,
    y1: 448.024,
    x2: 235.316,
    y2: 310.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4003_135",
    x1: 242.595,
    y1: 451.115,
    x2: 305.005,
    y2: 345.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4003_135",
    x1: 29.8971,
    y1: 281.022,
    x2: 210.759,
    y2: 258.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4003_135",
    x1: 13.4553,
    y1: 278.636,
    x2: 228.351,
    y2: 238.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4003_135",
    x1: 508.001,
    y1: 178.723,
    x2: 264.584,
    y2: 281.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4003_135",
    x1: 499.189,
    y1: 186.946,
    x2: 281.042,
    y2: 296.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4003_135",
    x1: 109.026,
    y1: 77.5784,
    x2: 196.514,
    y2: 302.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4003_135",
    x1: 146.949,
    y1: 133.809,
    x2: 216.922,
    y2: 287.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4003_135",
    x1: 149.572,
    y1: 58.4711,
    x2: 230.308,
    y2: 281.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4003_135",
    x1: 175.174,
    y1: 118.189,
    x2: 240.064,
    y2: 268.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4003_135",
    x1: 68.0264,
    y1: 111.011,
    x2: 115.351,
    y2: 292.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4003_135",
    x1: 79.5526,
    y1: 124.533,
    x2: 115.785,
    y2: 270.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4003_135",
    x1: 59.6172,
    y1: 131.617,
    x2: 131.814,
    y2: 321.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4003_135",
    x1: 73.5135,
    y1: 144.872,
    x2: 129.631,
    y2: 298.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4003_135",
    x1: 10.6192,
    y1: 203.619,
    x2: 111.885,
    y2: 339.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4003_135",
    x1: 26.2303,
    y1: 216.932,
    x2: 111.262,
    y2: 333.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4003_135",
    x1: 302.457,
    y1: 26.2263,
    x2: 317.834,
    y2: 296.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4003_135",
    x1: 316.022,
    y1: 29.2547,
    x2: 399.311,
    y2: 282.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4003_135",
    x1: 395.862,
    y1: 60.5971,
    x2: 308.722,
    y2: 295.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4003_135",
    x1: 401.952,
    y1: 56.2204,
    x2: 334.647,
    y2: 274.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_4003_135",
    x1: 467.568,
    y1: 326.245,
    x2: 307.448,
    y2: 365.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_4003_135",
    x1: 441.637,
    y1: 321.424,
    x2: 301.483,
    y2: 364.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_4003_135",
    x1: 462.34,
    y1: 377.642,
    x2: 282.387,
    y2: 324.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_4003_135",
    x1: 454.264,
    y1: 376.602,
    x2: 287.159,
    y2: 339.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_4003_135",
    x1: 507.711,
    y1: 156.741,
    x2: 294.723,
    y2: 285.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "white",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_4003_135",
    x1: 494.76,
    y1: 167.215,
    x2: 310.833,
    y2: 295.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_4003_135",
    x1: 504.198,
    y1: 245.675,
    x2: 295.299,
    y2: 262.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_4003_135",
    x1: 495.538,
    y1: 249.877,
    x2: 303.825,
    y2: 278.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_4003_135",
    x1: 477.168,
    y1: 123.388,
    x2: 304.329,
    y2: 302.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_4003_135",
    x1: 471.13,
    y1: 132.374,
    x2: 323.566,
    y2: 304.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_4003_135",
    x1: 200.065,
    y1: 442.634,
    x2: 283.548,
    y2: 262.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_4003_135",
    x1: 198.806,
    y1: 432.665,
    x2: 266.936,
    y2: 259.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_4003_135",
    x1: 425.404,
    y1: 404.278,
    x2: 212.381,
    y2: 311.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_4003_135",
    x1: 415.492,
    y1: 402.105,
    x2: 215.519,
    y2: 330.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_4003_135",
    x1: 319.467,
    y1: 464.545,
    x2: 277.897,
    y2: 246.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_4003_135",
    x1: 311.514,
    y1: 456.389,
    x2: 260.848,
    y2: 254.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_4003_135",
    x1: 154.24,
    y1: 400.097,
    x2: 246.025,
    y2: 346.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_4003_135",
    x1: 144.345,
    y1: 410.271,
    x2: 249.92,
    y2: 352.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_4003_135",
    x1: 117.85,
    y1: 420.582,
    x2: 254.903,
    y2: 354.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_4003_135",
    x1: 74.6446,
    y1: 399.881,
    x2: 219.922,
    y2: 320.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_4003_135",
    x1: 57.7419,
    y1: 379.209,
    x2: 180.323,
    y2: 244.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_4003_135",
    x1: 35.5989,
    y1: 335.392,
    x2: 112.214,
    y2: 209.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBackground);
export default __webpack_public_path__ + "static/media/light_background.9e07a239509d7bffaa516f116e45a6e5.svg";
export { ForwardRef as ReactComponent };